import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { UserInfoSlice, UserInfoStateTypes } from './userInfoSlice.interface';

const initialState: UserInfoSlice = {
  userInfo: {
    loading: true,
    data: null,
    meta: null,
    error: null,
  },
};

export const userInfoSlice = createSlice({
  name: 'UserInfo',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.userInfo = {
        loading: false,
        data: action.payload,
        meta: null,
        error: null,
      };
    },
    setUserInfo: (state, action) => {
      state.userInfo = {
        loading: false,
        data: { ...state.userInfo.data, ...action.payload },
        meta: null,
        error: null,
      };
    },

    setUserInfoLoading(state, action: PayloadAction<UserInfoStateTypes>) {
      state[action.payload].loading = true;
    },

    setUserInfoError(
      state,
      action: PayloadAction<{
        type: UserInfoStateTypes;
        err: any;
      }>
    ) {
      state[action.payload.type] = {
        loading: false,
        error: action.payload.err,
        data: null,
        meta: null,
      };
    },
  },
});

export const { setUser, setUserInfo, setUserInfoLoading, setUserInfoError } = userInfoSlice.actions;

export const userInfoState = (state: RootState) => state.userInfo.userInfo;

export default userInfoSlice.reducer;
